// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1M-tt","footer":"ModalUpdate_footer__TfecM"};